module.exports = __webpack_public_path__ + "img/card-text.1ef56e26.svg";